export default __webpack_public_path__ + "static/media/Igor-Kurganov.f752746c.png";